import {useChecklistData} from "../ChecklistDataContext";
import {renderNode} from "../../legacy/renderNodeLegacy";
import styles from "../checklist.module.css";

export const CheckItemIngress = ({ingress}: {ingress: string}) => {
    const {topicData} = useChecklistData();

    return (
        <div className={styles.ingressSection}>
            <div className={styles.contentBody}>
                {renderNode(topicData, ingress, {}, ingress)}
            </div>
        </div>
    );
};
